
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import HomePage from '../pages/home/page';
import NotFound from '../pages/NotFound';

const VpnServicePage = lazy(() => import('../pages/vpn-service/page'));
const FeaturesPage = lazy(() => import('../pages/features/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const SupportPage = lazy(() => import('../pages/support/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/vpn-service',
    element: <VpnServicePage />,
  },
  {
    path: '/features',
    element: <FeaturesPage />,
  },
  {
    path: '/contact',
    element: <SupportPage />,
  },
  {
    path: '/support',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
